import type { InjectionKey, Ref } from "vue";

export const labelInputKey: InjectionKey<{
  error: Ref<string | undefined>;
  setId: (id: string) => void;
}> = Symbol("labelInput");
